import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms-booking-add-date"
export default class extends Controller {
  static targets = ["addDateBoolean"]

  connect() {
    this.addDateBooleanTarget.value = ''
  }

  activate() {
    this.addDateBooleanTarget.value = '1'
  }
}
